import type { Sms as SmsData } from '@mathflat/domain/Sms'
import { format } from 'date-fns'
import { computed, makeObservable, observable } from 'mobx'
import { nanoid } from 'nanoid'

import { EMPTY_STRING_ID } from '@/constant/common'
import dateUtils from '@/utils/DateUtils'

import { DTO } from '../DTO'

export class Sms extends DTO implements SmsData {
  id = EMPTY_STRING_ID
  status: SmsData['status']
  target: SmsData['target']
  type: SmsData['type']
  studentName: SmsData['studentName']
  sender: SmsData['sender']
  receiver: SmsData['receiver']
  message: SmsData['message']
  fee: SmsData['fee']
  createDatetime: SmsData['createDatetime']

  constructor(data: SmsData) {
    super()

    makeObservable(this, {
      id: observable,
      status: observable,
      target: observable,
      type: observable,
      studentName: observable,
      sender: observable,
      receiver: observable,
      message: observable,
      fee: observable,
      createDatetime: observable,
      createDate: computed,
      sendDate: computed,
      sendDateHour: computed,
      sendTime: computed,
      korTargetType: computed,
      korStatus: computed,
    })

    this.id = nanoid()
    this.status = data.status
    this.target = data.target
    this.type = data.type
    this.studentName = data.studentName
    this.sender = data.sender
    this.receiver = data.receiver
    this.message = data.message
    this.fee = data.fee
    this.createDatetime = data.createDatetime
  }

  get createDate() {
    return new Date(this.createDatetime)
  }

  get sendDate() {
    const koDayOfWeek = dateUtils.toKoDayOfWeek(this.createDate)
    return format(this.createDate, `yyyy.MM.dd (${koDayOfWeek})`)
  }

  get sendDateHour() {
    return format(this.createDate, `yy.MM.dd HH:mm`)
  }

  get sendTime() {
    const afternoon = format(this.createDate, 'a') === 'AM' ? '오전' : '오후'
    return format(this.createDate, `${afternoon} h:mm`)
  }

  get korTargetType() {
    switch (this.target) {
      case 'PARENTS':
        return '부모'
      case 'STUDENT':
        return '학생'
    }
  }

  get korStatus() {
    switch (this.status) {
      case 'SUCCESS':
        return '성공'
      case 'FAIL':
        return '실패'
      case 'REQUESTED':
        return '전송중'
    }
  }
}
